import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';

const ChargeGroupSection = (props) => {

    const {title, children} = props;

    return (
        <div>

            <h5
                style={{
                textAlign: 'center',
                fontSize: '1.25rem',
                margin: '.75rem'
            }}>
                {TextFormatter.humanizeTitle(title)}

            </h5>

            <table className="bordered">
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    );
};

ChargeGroupSection.propTypes = {
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])

};
export default ChargeGroupSection;



// WEBPACK FOOTER //
// ./src/components/charges/ChargeGroupSection.js